// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"19fb4163","410":"9e0c8583","440":"ccb761fc","453":"d4025bed","600":"2f79f1df","809":"915ebe6e","919":"034b1d5f"}[chunkId] + ".chunk.js";
};